import React from 'react'
// import ServicesCard from '../components/ServicesCard';
// import'../css/footer.css';
 function Footer() {
  return (
    <div class="p-3 bg-black" id="footer"> 
    <div>
    <div class=" row my-5 mx-4" >
  <div class="d-flex justify-content-start col-md-6  col-lg-4  p-2 ">
<div class="">
  <h3 class="text-white"> Company</h3>
  <p class="text-white fs-5"> Apex Data Technologies </p>
  <p class="text-white fs-6"> <i class="  fa-solid fa-location-dot text-white "></i>
  Art of Living Building,
  <br/>  Poothole Road , <br/> Kuttipuzha Nagar ,<br/> Thrissur,Kerala-680004 
    </p>   
</div>
  </div>
  <div class=" d-flex justify-content-start col-md-6  col-lg-4 p-2 ">
  <div class="">
  <h3 class="text-white "> Page links..</h3>
  <div><a class="  fs-6 text-white text-decoration-none " href="#Services"> ..Services </a></div>
  <div><a class=" fs-6 text-white text-decoration-none" href="#team"> ..Team </a></div>
  <div><a class="  fs-6 text-white text-decoration-none " href="#about"> ..About Us</a></div>
  <div><a class="  fs-6 text-white text-decoration-none " href="#contact"> ..Contact Us</a> </div>
</div>

  </div>
  <div class="d-flex justify-content-start  col-md-6  col-lg-4 p-2 ">
  <div class="">
  <h3 class="text-white "> Contacts</h3>
  <p class="text-white fs-6"> <i class="  fa-solid fa-location-dot text-white "></i>  Art of Living Building,
  <br/>  Poothole Road , <br/> Kuttipuzha Nagar ,<br/> Thrissur,Kerala-680004 
  </p>
  <p class="text-white fs-6"> <i class="  fa-solid fa-calendar-days text-white "></i>   Mon-sat 10:00-5:00 </p>
  <p class="text-white fs-6">  <i class="  fa-solid fa-envelope text-white "></i>  apexdatatechnologies@gmail.com </p> 
  <p class="text-white fs-6">  <i class="  fa-solid fa-phone text-white "></i>  +91 9995885561 </p>  
</div> 
  </div>
</div>
<div class=" row bg-black ">
    <div class="col-md-6 col-lg-4 d-flex align-items-center justify-content-center " > 
    <a class=" m-2 text-decoration-none " href="/"> <i class="  fa-brands fa-facebook text-white fa-2x"></i>  </a>
    <a class=" m-2 text-decoration-none " href="/"> <i class="  fa-brands fa-twitter text-white  fa-2x"></i>  </a>
    <a class=" m-2 text-decoration-none " href="/"> <i class="  fa-brands fa-instagram text-white fa-2x"></i>  </a>
    <a class=" m-2 text-decoration-none " href="/"> <i class="  fa-brands fa-linkedin text-white fa-2x"></i>  </a>
    </div>
    <div class=" col-md-6  col-lg-8 d-flex align-items-center justify-content-center ">
      <div class="">
      <p  class=" fs-6   text-white text-center">© Copyright 2023 Apex Data Technologies All Rights Reserved . </p>     
     </div>    
    </div>
  </div>
      </div>       
    </div>
  )
}
export default Footer;